import { render } from "./readonly.vue?vue&type=template&id=201fd95c&scoped=true"
import script from "./readonly.vue?vue&type=script&lang=js"
export * from "./readonly.vue?vue&type=script&lang=js"

import "./readonly.vue?vue&type=style&index=0&id=201fd95c&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201fd95c"]])

export default __exports__